import { useState } from 'react';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';

export const OptionsRow = ({
  grid,
  options,
  required,
  question,
  onChange,
  value,
  ...rest
}) => {
  const [state, setState] = useState(false);

  const onResponse = (value) => {
    if (value === 'Other') setState(true);
    else setState(false);

    onChange(value);
  };

  return (
    <Grid item className="options-row" xs={grid || 12}>
      <FormControl className={rest.error ? 'error' : ''}>
        <FormLabel id="demo-radio-buttons-group-label">{question}</FormLabel>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={value}
          onChange={({ target: { value } }) => onResponse(value)}
          name="radio-buttons-group"
        >
          {options.split('\n').map((el) => {
            if (el === 'Other') {
              return (
                <Grid key={el} container>
                  <Grid item>
                    <FormControlLabel
                      key={el}
                      value={el}
                      label={el}
                      control={<Radio />}
                    />
                  </Grid>
                  {state ? (
                    <Grid item>
                      <TextField
                        size="small"
                        id="outlined"
                        required={required}
                        onChange={({ target: { value } }) => onChange(value)}
                      />
                    </Grid>
                  ) : null}
                </Grid>
              );
            }
            return (
              <FormControlLabel
                key={el}
                value={el}
                label={el}
                control={<Radio />}
              />
            );
          })}
        </RadioGroup>
        {rest.error ? <FormHelperText>{rest.helperText}</FormHelperText> : null}
      </FormControl>
    </Grid>
  );
};
